/**
 * Created by rorschach on 2018/1/24.
 */

import expirePlugin from "store/plugins/expire";
import storeStorage from "store/dist/store.modern";

// 用于替代localStorage, 因为低端安卓机不支持localStorage

storeStorage.addPlugin(expirePlugin);

// 这里为注销登录会删除的storage
const USER_DATA_KEYS = {
  // 微信授权key
  wxAuthKey: "wxAuthKey",
  // 登录token
  token: "token",
  // 登录用户信息 (请勿直接读取localStorage中的profile,不保证准确, 为了保证响应式更新, 请从storeMine.profile读取)
  profile: "profile",
  // 购物车选中的商品
  selectedCartItemIds: "selectedCartItemIds"
};

function setItem(k, v, expiration) {
  verifyKey(k);
  return storeStorage.set(k, v, expiration);
}

function getItem(k) {
  verifyKey(k);
  return storeStorage.get(k);
}

function removeItem(k) {
  verifyKey(k);
  return storeStorage.remove(k);
}

function clearAll() {
  return storeStorage.clearAll();
}

function clearUserData() {
  Object.values(USER_DATA_KEYS).forEach(k => {
    removeItem(k);
  });
}
function getInfo() {
  const keys = storeStorage.map((value, key) => {
    return key;
  });
  return {
    keys
  };
}

function verifyKey(k) {
  if (!k) {
    alert("Storage缓存异常, 请清空缓存重试");
    window.location.reload();
  }
}
const KEYS = {
  ...USER_DATA_KEYS,
  refreshToken: "refresh_token",
  token: "token",
  username: "username",
  openid: "openid",
  registerCode: "registerCode"
};

const storage = {
  KEYS,
  setItem,
  getItem,
  removeItem,
  clearAll,
  getInfo,
  clearUserData
};

export default storage;



// WEBPACK FOOTER //
// ./src/utils/xyStorage.js